<template>
	<form @submit.prevent="search" action="Index" asp-antiforgery="false">
		<div class="searchcontainer">
			<div class="search">
				<img src="../../static/shipment-search.png" />
				<input name="Id" type="text" placeholder="Enter consignment number" v-model="id" required />
				<button type="submit" class="ripple">Track shipment</button>
			</div>
		</div>

		<div v-if="isLoading">
			<div class="loader">
				<div class="loader__bar"></div>
				<div class="loader__bar"></div>
				<div class="loader__bar"></div>
				<div class="loader__bar"></div>
				<div class="loader__bar"></div>
				<div class="loader__ball"></div>
			</div>
		</div>
		<div v-else-if="consignmentDetails" class="container page-content">
			<tracking-consignment :consignment-detail="consignmentDetails"></tracking-consignment>
		</div>
	</form>
</template>

<script>
	import axios from 'axios'
	export default {
		props: {
			connote: { type: String, default: null },
            account: { type: Number, default: null }
		},
		data() {
            var urlQueryParams = new URLSearchParams(window.location.search);

			return {
				id: "",
				consignmentDetails: null,
				isLoading: null,
                accountId: urlQueryParams.get('account'),
			}
		},
		mounted() {
			if (this.connote) {
				this.id = this.connote
				this.search()
			}
		},
		methods:
		{
			search() {
				this.isLoading = true

				axios.post('/Index?handler=Consignment', { id: this.id, accountId: this.accountId })
					.then(data => {
						this.isLoading = false
						this.consignmentDetails = data
					})
					.catch(() => {
                        this.isLoading = false
                        this.consignmentDetails = {
                            data: {
								status: "There was an error finding the consignment"
                            }
                        }
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.search {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align:center;
	}	
</style>